import React, { useState } from "react";
import Swal from "sweetalert2";
import IncidentsData from "./incidents_data";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";

function Incidents () {
    const [masterValue, setMasterValue] = useState('');
    const [error, setError] = useState('');
    const [radioValue, setRadioValue] = useState('');
    const [radioError, setRadioError] = useState('');
    const [masterData, setMasterData] = useState(null);
    const [view, setView] = useState('input');

    const mockData = [
        {
          number: '111-12345678',
          type: 'directa',
          merchandiseType: 'Cont activos',
          pzas: 2,
          weight: 27.00,
          cliente: 'FedEx',
          fecha: '2025-04-10',
          origen: 'CMX',
          destino: 'GDL',
          isTransit: true,
          subproducts: [],
        },
        {
          number: '222-87654321',
          type: 'parcial',
          merchandiseType: 'Carga general',
          pzas: 4,
          weight: 48.30,
          cliente: 'UPS',
          fecha: '2025-04-11',
          origen: 'MTY',
          destino: 'TIJ',
          isTransit: false,
          subproducts: [
            { hbs: 'HBS-001', fecha: '2025-04-10', piezas: 1, peso: 5, volume: 17.89 },
            { hbs: 'HBS-002', fecha: '2025-04-11', piezas: 3, peso: 4, volume: 22.43 },
          ]
        }
    ];

    const handleInputChange = (e) => {
        let value = e.target.value; // Permitimos letras y números

        if (value.length > 3 && value[3] !== "-") {
            value = value.slice(0, 3) + "-" + value.slice(3);
        }

        setMasterValue(value);
        if (error) setError(''); // Borra el error cuando el usuario escribe
    };

    const handleRadioChange = (e) => {
        setRadioValue(e.target.value);
        if (radioError) setRadioError('');
    };

    const handleAccept = () => {
        if (!masterValue.trim()) {  // Verifica si el input está vacío
            setError("Este campo es obligatorio");
            return;
        }

        if (!radioValue) {
            setRadioError("Selecciona una de estas opciones.");
            return;
        }

        const guide = mockData.find((item) => item.number === masterValue);
        if (guide) {
            if (guide.isTransit === false && (radioValue === "3")) {
                Swal.fire({
                    title: "La guía no es de tránsito, favor de verificar",
                    icon: "warning",
                    iconColor: '#FCC732',
                    customClass: {
                        confirmButton: 'btn-ok',
                        title: 'alert-title',
                        popup: 'alert-bg'
                    }
                });
            } else {
                setMasterData(guide); // guardamos todo el objeto
                setView('incidentsShowData');
           }
        } else if (!guide && (radioValue === "1")) {
            Swal.fire({
                title: "La guía no existe o no es de importación, favor de verificar",
                icon: "warning",
                iconColor: '#FCC732',
                customClass: {
                    confirmButton: 'btn-ok',
                    title: 'alert-title',
                    popup: 'alert-bg'
                }
            });
        } else if (!guide && (radioValue === "2" )) {
            Swal.fire({
                title: "La guía no existe o no es de exportación, favor de verificar",
                icon: "warning",
                iconColor: '#FCC732',
                customClass: {
                    confirmButton: 'btn-ok',
                    title: 'alert-title',
                    popup: 'alert-bg'
                }
            });
        } else {
            Swal.fire({
                title: "La guía no existe, favor de verificar",
                icon: "warning",
                iconColor: '#FCC732',
                customClass: {
                    confirmButton: 'btn-ok',
                    title: 'alert-title',
                    popup: 'alert-bg'
                }
            });
        }
    }

    return(
        <>
            <Helmet>
                <title>Horus | Incidencias</title>
            </Helmet>
            <ScrollToTop />
            <div className="container-fluid">
                {view === 'input' && (
                <div className="row justify-content-center">
                    <div className="col-6 col-md-3">
                        <label htmlFor="inputMaster" className="amc-label">Master</label>
                        <input 
                            type="text"
                            className="form-control"
                            id="inputMaster"
                            value={masterValue}
                            onChange={handleInputChange}
                        />
                        {error && <small className="text-danger">{error}</small>}
                    </div>
                    <div className="col-6 col-md-3">
                        <div className="form-group mt-4">
                            <label className="me-4 amc-label">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="type" 
                                    id="radio1" 
                                    value="1" 
                                    checked={radioValue === "1"}
                                    onChange={handleRadioChange}
                                />
                                IMPO
                            </label>
                            <label className="me-4 amc-label">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="type" 
                                    id="radio2" 
                                    value="2"
                                    checked={radioValue === "2"}
                                    onChange={handleRadioChange}
                                />
                                EXPO
                            </label>

                            <label className="me-4 amc-label">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="type" 
                                    id="radio3" 
                                    value="3"
                                    checked={radioValue === "3"}
                                    onChange={handleRadioChange}
                                />
                                TRÁNSITO
                            </label>

                            {radioError && <div><small className="text-danger">{radioError}</small></div>}
                        </div>

                        <div className="btns mt-3 d-flex justify-content-end gap-3">
                            <button className='btnn' onClick={handleAccept}>Aceptar</button>
                        </div>
                    </div>
                </div>
                )}

                {view === 'incidentsShowData' && <IncidentsData master={masterData} />}
            </div>
        </>
    );
}

export default Incidents;